import React, { createContext, useContext, useMemo } from "react";
import { MatchSetInfo } from "../types/health";

interface MatchSetsContextValue {
  matchSets: MatchSetInfo[];
  isLoading: boolean;
}

const MatchSetsContext = createContext<MatchSetsContextValue>({
  matchSets: [],
  isLoading: false,
});

export const MatchSetsProvider: React.FC<{
  matchSets: MatchSetInfo[];
  isLoading: boolean;
  children: React.ReactNode;
}> = ({ matchSets, isLoading, children }) => {
  const value = useMemo(
    () => ({ matchSets, isLoading }),
    [matchSets, isLoading]
  );
  return (
    <MatchSetsContext.Provider value={value}>
      {children}
    </MatchSetsContext.Provider>
  );
};

export const useMatchSets = () => useContext(MatchSetsContext);
